module.exports = __webpack_public_path__ + "img/zx_gray.e5456653.png";